import * as React from "react";
import { PaginationData } from "../types";
import styles from "./pagination.module.sass";

export type LoadMoreHandler = () => void;

type PaginationProps = PaginationData & {
  onLoadMore: LoadMoreHandler;
  isLoading?: boolean;
};

export const LoadMoreButton = ({
  onLoadMore,
  isLoading,
  currentPage,
  perPage,
  resultsCount,
}: PaginationProps): JSX.Element | null => {
  if (currentPage * perPage + 1 > resultsCount) {
    return null;
  }

  return (
    <div className={styles.showMoreButton}>
      <button
        type="button"
        className={"show-more button active"}
        onClick={(event) => {
          onLoadMore();
        }}
        disabled={isLoading}
      >
        Načíst další
      </button>
    </div>
  );
};
